import { render, staticRenderFns } from "./BirdIdLogo.vue?vue&type=template&id=0fa1af97&scoped=true&"
import script from "./BirdIdLogo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BirdIdLogo.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa1af97",
  null
  
)

export default component.exports